<script>
import Gridpagination from './GridPagination';
import Gridtemplate from './GridTemplate';

export default {
    props: {
        name: {
            type: String,
            default: 'my-table'
        },
        apiUrl: {
            type: String,
            default: ''
        },
        fields: {
            type: Array,
            default () {
                return [];
            }
        },
        useFilter: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Shop Grid 03 Col'
        },
        corLoading: {
            type: String,
            default: '#000'
        },
        css: {
            type: Object,
            default () {
                return {
                    table: {
                        tableClass: 'table dataTable table-striped',
                        tableWrapper: '',
                        tableHeaderClass: 'thead-light',
                        tableBodyClass: 'table-striped',
                        loadingClass: 'loading',
                        ascendingIcon: '',
                        descendingIcon: '',
                        ascendingClass: 'sorting_asc',
                        descendingClass: 'sorting_desc',
                        sortableIcon: '',
                        handleIcon: ''
                    },
                    pagination: {
                        wrapperClass: 'pagination m--pull-left',
                        activeClass: 'active',
                        disabledClass: 'disabled',
                        pageClass: 'btn m-btn--pill btn-outline-primary border-0 page-class',
                        linkClass: 'btn m-btn--pill btn-outline-primary border-0 link-class',
                        icons: {
                            first: 'fa fa-angle-double-left',
                            prev: 'fa fa-angle-left',
                            next: 'fa fa-angle-right',
                            last: 'fa fa-angle-double-right'
                        }
                    }
                };
            }
        },
        showExtraFilters: {
            type: Boolean,
            default: false
        },
        // 18/09/2026: texto do cabecalho, ex. "Exibindo {de} a {ate} de {total} descontos ativos."
        textoExibindo: {
            type: String,
            default: ''
        },
        appendParams: {
            type: Object,
            default () {
                return {};
            }
        },
        showPagination: {
            type: Boolean,
            default: true
        },
        showListViewType: {
            type: Boolean,
            default: true
        },
        customClass: {
            type: String,
            default: 'col-xl-9'
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        customItemTitleClass: {
            type: String,
            default: 'custom-item-title'
        },
        fullLink: {
            type: Boolean,
            default: false
        },
        loadingStringTemplate: {
            type: String,
            default: 'Sem resultado'
        }
    },
    components: {
        Gridtemplate,
        Gridpagination,
        // 'filter-bar': FilterBar,
        // 'my-pagination': MyPagination,
        'stretch': VueLoadingSpinner.Stretch
    },
    data () {
        return {
            exibindo: '', // 18/09/2026
            moreParams: {},
            perPage: localStorage.getItem(this.$props.name + '_perPage') ? localStorage.getItem(this.$props.name + '_perPage') : 21,
            loadingString: this.$props.loadingStringTemplate
        };
    },
    mounted () {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
    },
    watch: {
        perPage () {
            localStorage.setItem(this.$props.name + '_perPage', this.perPage);
            this.$nextTick(() => {
                this.$refs.vuetable.refresh();
            });
        }
    },
    render (createElement) {
        return createElement(
            'div',
            {
                attrs: {
                    'class': this.customClass
                }
            },
            [
                createElement(
                    'div',
                    {
                    },
                    [
                        this.renderLoading(createElement),
                        this.renderVuetable(createElement)
                    ]
                ),
                this.renderPagination(createElement)
            ]
        );
    },
    methods: {
        onPaginationData (paginationData) {
            if (this.$parent.onPaginationData) {
                this.$parent.onPaginationData(paginationData);
            }
            // 18/09/2026: cabecalho "Exibindo x a y de z" (igual ao "Navegue por marca") e aviso so desta grade
            this.exibindo = this.textoExibindo && paginationData && paginationData.total
                ? this.textoExibindo
                    .replace('{de}', paginationData.from || 0)
                    .replace('{ate}', paginationData.to || 0)
                    .replace('{total}', paginationData.total)
                : '';
            this.$emit('pagination-data', paginationData);

            if (this.$refs.pagination) this.$refs.pagination.setPaginationData(paginationData);
            if (this.$refs.paginationInfo) this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage (page) {
            this.noDataMessage = $(this.$refs.loadingSpinner).clone().removeClass('d-none').html();
            this.$refs.vuetable.changePage(page);
        },
        onFilterSet (filterText) {
            Object.assign(this.moreParams, {'filter': filterText});

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset () {
            this.$emit('clear-extra-fields');
            this.moreParams = {};
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        renderFilter (createElement) {
            if (!this.useFilter) {
                return;
            }
            return createElement('filter-bar', {
                ref: 'filter',
                props: {
                    showExtraFilters: this.$props.showExtraFilters
                },
                scopedSlots: this.$vnode.data.scopedSlots
            });
        },
        renderVuetable (createElement) {
            return createElement(
                'gridtemplate',
                {
                    ref: 'vuetable',
                    props: {
                        loadOnStart: this.loadOnStart,
                        apiUrl: this.apiUrl,
                        fields: this.fields,
                        trackBy: this.trackBy,
                        css: this.css.table,
                        dataPath: this.dataPath,
                        paginationPath: '',
                        perPage: Number.parseInt(this.perPage),
                        sortOrder: this.sortOrder,
                        appendParams: this.appendParams,
                        apiMode: this.apiMode,
                        usePreload: this.usePreload,
                        httpFetch: this.httpFetch,
                        data: this.data,
                        tableHeight: this.tableHeight,
                        noDataTemplate: this.loadingString,
                        detailRowId: this.detailRowId,
                        detailRowTransition: 'expand',
                        detailRowComponent: this.detailRowComponent,
                        wrapperClass: 'vuetable-wrapper',
                        title: this.title,
                        exibindo: this.exibindo,
                        showListViewType: this.showListViewType,
                        showTitle: this.showTitle,
                        customItemTitleClass: this.customItemTitleClass,
                        fullLink: this.fullLink
                    },
                    on: {
                        'vuetable:pagination-data': this.onPaginationData,
                        'vuetable:loading': this.showLoader,
                        'vuetable:loaded': this.hideLoader
                    },
                    scopedSlots: this.$vnode.data.scopedSlots
                }
            );
        },
        renderLoading (createElement) {
            return createElement('div', {
                ref: 'loadingSpinner',
                attrs: {
                    class: 'loading-spinner-container d-none'
                }
            }, [createElement('div', {
                attrs: {
                    class: 'd-inline-block'
                }
            }, [createElement('stretch', {attrs: {background: this.corLoading} })])]);
        },
        renderPagination (createElement) {
            return createElement('gridpagination', {
                ref: 'pagination',
                props: {
                    infoTemplate: 'Mostrando {from} - {to} de {total}',
                    noDataTemplate: this.loadingString,
                    showPagination: this.showPagination
                },
                on: {
                    'vuetable-pagination:change-page': this.onChangePage
                }
            });
        },
        showLoader () {
            this.loadingString = $(this.$refs.loadingSpinner).clone().removeClass('d-none').html();
            this.$refs.vuetable.tableData = [];
        },
        hideLoader () {
            this.loadingString = this.loadingStringTemplate;
        }
    }
};
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>
